import { CSSProperties } from 'react';
import { DropDirection } from '../types';

interface DropLineProps {
  direction: DropDirection
}

export function DropLine(props: DropLineProps) {
  const { direction } = props;

  let position: CSSProperties = {
    top: direction === 'top' ? -3 : undefined,
    bottom: direction === 'bottom' ? -3 : undefined,
    left: 0,
    right: 0,
    height: 3,
  };

  if (direction === 'left' || direction === 'right') {
    position = {
      top: 0,
      bottom: 0,
      left: direction === 'left' ? -3 : undefined,
      right: direction === 'right' ? -3 : undefined,
      width: 3,
    };
  }

  return (
    <div
      style={{
        position: 'absolute',
        backgroundColor: 'var(--dropline)',
        ...position,
      }}
    />
  );
}
